import React, { Component } from 'react'
import $ from 'jquery'
import axios from 'axios'
import swal from 'sweetalert2'
import { FormattedMessage } from 'react-intl'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import Config from '../../commons/config/Config.js'
import Security from '../../commons/security/Security.js'
import * as Constants from '../atributoDinamico/constants.js'
import { castValoresDinamicos } from '../atributoDinamico/helpers.js'
import backendStrings from '../../lang/backendStrings.js'
import Timezone from '../../commons/timezone/Timezone.js'

const configAxios = {
	headers: {
		'Authorization-Token': localStorage.getItem("token")
	}
};

// VEC-3362: revisión ítem por ítem de un checklist ya completado. El supervisor marca
// varias decisiones en memoria (decisionesBorrador) y recién al final se hace un solo
// POST /formulario/{id}/validar-items. Nunca dispara /validar ni /cancelar: queda
// totalmente desacoplado del estado/candado del checklist (ver docs/vec-3362-checklist-validacion-granular.md).
// VEC-3599: selección múltiple de ítems para aplicarles una sola decisión y un solo
// comentario (seleccionMultiple). Convive con la decisión ítem por ítem existente:
// usa el mismo POST /validar-items, solo cambia cuántas entradas trae el payload.
class ValidacionGranularModal extends Component {
	constructor(props) {
		super(props);
		this.ajaxHandler = new AjaxHandler();
		this.concluido = false;
		this.checklistCompletado = false;
		// El comentario es siempre opcional (validar o rechazar) y se gestiona con el
		// mismo permiso que el flujo binario viejo (FormulariosGridRow::handleConfirmation).
		this.hasPermissionComentar = Security.hasPermission('CHECKLIST_COMENTAR');

		this.state = {
			modalId: 'modal_validacion_granular_' + props.formularioId,
			loading: true,
			submitting: false,
			valores_dinamicos: [],
			decisionesBorrador: {},
			seleccionMultiple: new Set(),
		};

		this.handleCerrar = this.handleCerrar.bind(this);
		this.handleConcluir = this.handleConcluir.bind(this);
		this.openImage = this.openImage.bind(this);
		this.toggleSeleccionMultiple = this.toggleSeleccionMultiple.bind(this);
		this.limpiarSeleccionMultiple = this.limpiarSeleccionMultiple.bind(this);
		this.toggleSeleccionarTodos = this.toggleSeleccionarTodos.bind(this);
		this.aplicarDecisionMasiva = this.aplicarDecisionMasiva.bind(this);
	}

	componentDidMount() {
		this.ajaxHandler.subscribe(this);
		let component = this;
		$('#' + this.state.modalId).modal({ backdrop: 'static' });
		$('#' + this.state.modalId).on('hidden.bs.modal', function () {
			if (component.concluido) {
				component.props.onConcluido(component.checklistCompletado);
			} else {
				component.props.onClose();
			}
		});
		this.cargarFormulario();
	}

	componentWillUnmount() {
		$('#' + this.state.modalId).off('hidden.bs.modal');
		this.ajaxHandler.unsubscribe();
	}

	cargarFormulario() {
		this.setState({ loading: true });
		let component = this;
		return this.ajaxHandler.getJson('/formulario/' + this.props.formularioId).then(function (formulario) {
			let valores_dinamicos = castValoresDinamicos(formulario.tipo_formulario.atributos_dinamicos, formulario.valores_dinamicos, false);
			component.setState({ valores_dinamicos: valores_dinamicos, loading: false });
			return valores_dinamicos;
		}).catch(function (error) {
			console.log(error);
			component.setState({ loading: false });
		});
	}

	handleCerrar() {
		$('#' + this.state.modalId).modal('hide');
	}

	openImage(adjunto_id) {
		let config = Object.assign({}, configAxios, { responseType: 'blob' });
		axios.get(Config.get('apiUrlBase') + '/adjuntos/files/' + adjunto_id, config).then(response => {
			if (response.status === 200) {
				let fileUrl = URL.createObjectURL(response.data);
				window.open(fileUrl)
			}
		}).catch((e) => { console.log(e) });
	}

	marcarValido(valorDinamico) {
		let intl = this.props.intl;
		let component = this;
		// Mismo fix de foco que marcarInvalido: el swal se monta fuera del modal Bootstrap.
		$(document).off('focusin.modal');
		swal({
			title: intl.formatMessage({ id: 'formularios.validacionGranular.validar_titulo', defaultMessage: 'Validar ítem' }),
			text: intl.formatMessage({ id: 'formularios.validacionGranular.validar_texto', defaultMessage: 'Ingresá un motivo (opcional, máx. 240 caracteres).' }),
			icon: 'question',
			...(this.hasPermissionComentar ? {
				input: 'textarea',
				inputPlaceholder: intl.formatMessage({ id: 'formularios.validacionGranular.motivo_placeholder_validar', defaultMessage: 'Motivo (opcional)...' }),
				inputAttributes: { maxlength: 240 },
			} : {}),
			showCancelButton: true,
			confirmButtonText: intl.formatMessage({ id: 'formularios.validacionGranular.boton_validar', defaultMessage: 'Validar' }),
			cancelButtonText: intl.formatMessage({ id: 'formularios.validacionGranular.boton_cancelar_swal', defaultMessage: 'Cancelar' }),
			inputValidator: (value) => {
				if (value && value.trim().length > 240) {
					return intl.formatMessage({ id: 'formularios.validacionGranular.motivo_muy_largo_swal', defaultMessage: 'El motivo no puede superar los 240 caracteres.' });
				}
				return null;
			},
		}).then((result) => {
			if (result.value !== undefined && result.value !== false) {
				let motivo = (typeof result.value === 'string' && result.value.trim()) ? result.value.trim() : null;
				component.setState(function (prevState) {
					let decisionesBorrador = Object.assign({}, prevState.decisionesBorrador);
					decisionesBorrador[valorDinamico.id] = {
						decision: Constants.ID_DECISION_VALIDO,
						motivo: motivo,
						ultima_validacion_id: valorDinamico.ultima_validacion ? valorDinamico.ultima_validacion.id : null,
					};
					return { decisionesBorrador: decisionesBorrador };
				});
			}
		});
	}

	marcarInvalido(valorDinamico) {
		let intl = this.props.intl;
		let component = this;
		// El modal Bootstrap 4 engancha un handler focusin.modal en document que devuelve el foco
		// al modal apenas detecta que salió de él. El swal se monta en document.body, fuera del
		// modal, así que cada tecla tipeada en el textarea perdía el foco de inmediato (el foco
		// volvía al modal antes de que React procesara la tecla). Sacar el handler alcanza para
		// destrabar el textarea; no hace falta re-engancharlo (el modal sigue funcionando igual,
		// solo deja de forzar el foco de vuelta si el usuario lo abandona por otro medio).
		$(document).off('focusin.modal');
		swal({
			title: intl.formatMessage({ id: 'formularios.validacionGranular.rechazar_titulo', defaultMessage: 'Rechazar ítem' }),
			text: intl.formatMessage({ id: 'formularios.validacionGranular.rechazar_texto', defaultMessage: 'Ingresá el motivo del rechazo (opcional, máx. 240 caracteres).' }),
			icon: 'warning',
			...(this.hasPermissionComentar ? {
				input: 'textarea',
				inputPlaceholder: intl.formatMessage({ id: 'formularios.validacionGranular.motivo_placeholder', defaultMessage: 'Motivo del rechazo (opcional)...' }),
				inputAttributes: { maxlength: 240 },
			} : {}),
			showCancelButton: true,
			confirmButtonText: intl.formatMessage({ id: 'formularios.validacionGranular.boton_rechazar', defaultMessage: 'Rechazar' }),
			cancelButtonText: intl.formatMessage({ id: 'formularios.validacionGranular.boton_cancelar_swal', defaultMessage: 'Cancelar' }),
			inputValidator: (value) => {
				if (value && value.trim().length > 240) {
					return intl.formatMessage({ id: 'formularios.validacionGranular.motivo_muy_largo_swal', defaultMessage: 'El motivo no puede superar los 240 caracteres.' });
				}
				return null;
			},
		}).then((result) => {
			if (result.value !== undefined && result.value !== false) {
				let motivo = (typeof result.value === 'string' && result.value.trim()) ? result.value.trim() : null;
				component.setState(function (prevState) {
					let decisionesBorrador = Object.assign({}, prevState.decisionesBorrador);
					decisionesBorrador[valorDinamico.id] = {
						decision: Constants.ID_DECISION_INVALIDO,
						motivo: motivo,
						ultima_validacion_id: valorDinamico.ultima_validacion ? valorDinamico.ultima_validacion.id : null,
					};
					return { decisionesBorrador: decisionesBorrador };
				});
			}
		});
	}

	marcarReapertura(valorDinamico) {
		this.setState(function (prevState) {
			let decisionesBorrador = Object.assign({}, prevState.decisionesBorrador);
			decisionesBorrador[valorDinamico.id] = {
				decision: Constants.ID_DECISION_CANCELADO,
				motivo: null,
				ultima_validacion_id: valorDinamico.ultima_validacion ? valorDinamico.ultima_validacion.id : null,
			};
			return { decisionesBorrador: decisionesBorrador };
		});
	}

	// El comentario es opcional en las dos decisiones — cuando no hay motivo, se muestra
	// "Sin comentario" en vez de omitir el paréntesis en silencio.
	formatoMotivo(motivo) {
		let intl = this.props.intl;
		let texto = motivo ? motivo : intl.formatMessage({ id: 'formularios.validacionGranular.sin_comentario', defaultMessage: 'Sin comentario' });
		return ' (' + texto + ')';
	}

	quitarMarca(valorDinamicoId) {
		this.setState(function (prevState) {
			let decisionesBorrador = Object.assign({}, prevState.decisionesBorrador);
			delete decisionesBorrador[valorDinamicoId];
			return { decisionesBorrador: decisionesBorrador };
		});
	}

	toggleSeleccionMultiple(valorDinamicoId) {
		this.setState(function (prevState) {
			let seleccionMultiple = new Set(prevState.seleccionMultiple);
			if (seleccionMultiple.has(valorDinamicoId)) {
				seleccionMultiple.delete(valorDinamicoId);
			} else {
				seleccionMultiple.add(valorDinamicoId);
			}
			return { seleccionMultiple: seleccionMultiple };
		});
	}

	limpiarSeleccionMultiple() {
		this.setState({ seleccionMultiple: new Set() });
	}

	toggleSeleccionarTodos() {
		let pendientesIds = this.itemsPendientesDeDecision().map(function (vd) { return vd.id; });
		this.setState(function (prevState) {
			let todosSeleccionados = pendientesIds.length > 0 && pendientesIds.every(function (id) { return prevState.seleccionMultiple.has(id); });
			return { seleccionMultiple: todosSeleccionados ? new Set() : new Set(pendientesIds) };
		});
	}

	// Filtra contra el estado vigente en vez de limpiar seleccionMultiple en cada acción
	// individual: un ítem tildado puede perder su casilla (se decide por el botón ✓/✕
	// individual sin pasar por la selección) sin que haga falta sincronizar el Set a mano.
	idsSeleccionadosValidos() {
		let component = this;
		return Array.from(this.state.seleccionMultiple).filter(function (id) {
			let valorDinamico = component.state.valores_dinamicos.find(function (vd) { return vd.id === id; });
			if (!valorDinamico) return false;
			let decisionActual = component.decisionActualDe(valorDinamico);
			return decisionActual === null || decisionActual === Constants.ID_DECISION_CANCELADO;
		});
	}

	// VEC-3599: aplica una sola decisión y un solo comentario a toda la selección múltiple.
	// Mismo POST /validar-items que la decisión ítem por ítem — acá solo cambia que el
	// payload trae varias entradas con la misma decision/motivo en vez de una.
	aplicarDecisionMasiva(decision) {
		let intl = this.props.intl;
		let component = this;
		let ids = this.idsSeleccionadosValidos();
		if (ids.length === 0) return;

		let esRechazo = decision === Constants.ID_DECISION_INVALIDO;
		let cantidad = ids.length;
		// Mismo fix de foco que marcarInvalido/marcarValido: el swal se monta fuera del modal.
		$(document).off('focusin.modal');
		swal({
			title: intl.formatMessage(
				{
					id: esRechazo ? 'formularios.validacionGranular.rechazar_masivo_titulo' : 'formularios.validacionGranular.validar_masivo_titulo',
					defaultMessage: esRechazo ? 'Rechazar {cantidad} ítem(s)' : 'Validar {cantidad} ítem(s)',
				},
				{ cantidad: cantidad }
			),
			text: intl.formatMessage(
				{
					id: esRechazo ? 'formularios.validacionGranular.rechazar_masivo_texto' : 'formularios.validacionGranular.validar_masivo_texto',
					defaultMessage: esRechazo
						? 'Ingresá el motivo del rechazo (opcional, máx. 240 caracteres). Se aplica a los {cantidad} ítem(s) seleccionados.'
						: 'Ingresá un motivo (opcional, máx. 240 caracteres). Se aplica a los {cantidad} ítem(s) seleccionados.',
				},
				{ cantidad: cantidad }
			),
			icon: esRechazo ? 'warning' : 'question',
			...(this.hasPermissionComentar ? {
				input: 'textarea',
				inputPlaceholder: intl.formatMessage({
					id: esRechazo ? 'formularios.validacionGranular.motivo_placeholder' : 'formularios.validacionGranular.motivo_placeholder_validar',
					defaultMessage: esRechazo ? 'Motivo del rechazo (opcional)...' : 'Motivo (opcional)...',
				}),
				inputAttributes: { maxlength: 240 },
			} : {}),
			showCancelButton: true,
			confirmButtonText: intl.formatMessage({
				id: esRechazo ? 'formularios.validacionGranular.boton_rechazar' : 'formularios.validacionGranular.boton_validar',
				defaultMessage: esRechazo ? 'Rechazar' : 'Validar',
			}),
			cancelButtonText: intl.formatMessage({ id: 'formularios.validacionGranular.boton_cancelar_swal', defaultMessage: 'Cancelar' }),
			inputValidator: (value) => {
				if (value && value.trim().length > 240) {
					return intl.formatMessage({ id: 'formularios.validacionGranular.motivo_muy_largo_swal', defaultMessage: 'El motivo no puede superar los 240 caracteres.' });
				}
				return null;
			},
		}).then((result) => {
			if (result.value !== undefined && result.value !== false) {
				let motivo = (typeof result.value === 'string' && result.value.trim()) ? result.value.trim() : null;
				component.setState(function (prevState) {
					let decisionesBorrador = Object.assign({}, prevState.decisionesBorrador);
					ids.forEach(function (id) {
						let valorDinamico = prevState.valores_dinamicos.find(function (vd) { return vd.id === id; });
						decisionesBorrador[id] = {
							decision: decision,
							motivo: motivo,
							ultima_validacion_id: valorDinamico && valorDinamico.ultima_validacion ? valorDinamico.ultima_validacion.id : null,
						};
					});
					return { decisionesBorrador: decisionesBorrador, seleccionMultiple: new Set() };
				});
			}
		});
	}

	// 409: otro supervisor decidió sobre alguno de estos ítems mientras el modal estaba
	// abierto. El backend no expone el detalle del conflicto a través del flujo estándar
	// de AjaxHandler (ver nota en el reporte final), así que se re-obtiene el formulario y
	// se detectan los ítems en conflicto comparando el ultima_validacion_id que se había
	// enviado contra el que quedó vigente: si difiere, alguien más decidió ese ítem.
	manejarConflicto() {
		let intl = this.props.intl;
		let component = this;
		this.cargarFormulario().then(function (valores_dinamicos) {
			if (!valores_dinamicos) return;
			let decisionesBorrador = Object.assign({}, component.state.decisionesBorrador);
			let itemsEnConflicto = [];
			valores_dinamicos.forEach(function (vd) {
				let pendiente = decisionesBorrador[vd.id];
				if (pendiente) {
					let idVigenteActual = vd.ultima_validacion ? vd.ultima_validacion.id : null;
					if (idVigenteActual !== pendiente.ultima_validacion_id) {
						itemsEnConflicto.push(vd.nombre);
						delete decisionesBorrador[vd.id];
					}
				}
			});
			component.setState({ decisionesBorrador: decisionesBorrador, submitting: false });
			swal({
				title: intl.formatMessage({ id: 'formularios.validacionGranular.conflicto_titulo', defaultMessage: 'Conflicto de validación' }),
				text: itemsEnConflicto.length > 0
					? intl.formatMessage(
						{ id: 'formularios.validacionGranular.conflicto_texto_items', defaultMessage: 'Estos ítems fueron decididos por otro supervisor mientras revisabas y se actualizaron: {items}' },
						{ items: itemsEnConflicto.join(', ') }
					)
					: intl.formatMessage({ id: 'formularios.validacionGranular.conflicto_texto', defaultMessage: 'Uno o más ítems fueron decididos por otro supervisor mientras revisabas. Se actualizó la información.' }),
				icon: 'info',
			});
		});
	}

	handleConcluir() {
		let component = this;
		let intl = this.props.intl;
		let decisionesBorrador = this.state.decisionesBorrador;
		let ids = Object.keys(decisionesBorrador);
		if (ids.length === 0) return;

		let payload = ids.map(function (id) {
			let item = decisionesBorrador[id];
			return {
				valor_dinamico_id: parseInt(id, 10),
				decision: item.decision,
				motivo: item.motivo ? item.motivo : null,
				ultima_validacion_id: item.ultima_validacion_id,
			};
		});

		this.setState({ submitting: true });

		this.ajaxHandler.fetch('/formulario/' + this.props.formularioId + '/validar-items', {
			method: 'POST',
			silent: true,
			body: JSON.stringify(payload),
		}).then(function (response) {
			if (response.status === 200) {
				component.concluido = true;
				response.json().then(function (data) {
					component.checklistCompletado = !!(data && data.checklist_completado);
					swal({
						title: intl.formatMessage({ id: 'formularios.validacionGranular.exito_titulo', defaultMessage: 'Validación registrada' }),
						icon: 'success',
					}).then(function () {
						$('#' + component.state.modalId).modal('hide');
					});
				});
			} else if (response.status === 400) {
				response.json().then(function (data) {
					let key = data && data.error;
					let descriptor = (key && backendStrings[key]) ? backendStrings[key] : backendStrings['errors.default'];
					component.setState({ submitting: false });
					swal({
						title: intl.formatMessage(descriptor),
						icon: 'error',
					});
				});
			} else {
				component.setState({ submitting: false });
			}
		}).catch(function (error) {
			if (error && error.status === 409) {
				component.manejarConflicto();
			} else {
				component.setState({ submitting: false });
				component.ajaxHandler.handleError(error);
			}
		});
	}

	// Mismo criterio que usa el backend (ValidacionGranularService::completarChecklistSiCorresponde)
	// para decidir qué ítems cuentan para "todos decididos": activo y no ERIC_IA.
	esItemRelevante(valorDinamico) {
		if (!valorDinamico || !valorDinamico.activo) return false;
		return parseInt(valorDinamico.tipoValor, 10) !== Constants.ID_ERIC_IA;
	}

	decisionActualDe(valorDinamico) {
		let borrador = this.state.decisionesBorrador[valorDinamico.id];
		let vigente = valorDinamico.ultima_validacion;
		let vigenteActiva = !!(vigente && vigente.decision !== Constants.ID_DECISION_CANCELADO);
		return borrador ? borrador.decision : (vigenteActiva ? vigente.decision : null);
	}

	itemsPendientesDeDecision() {
		let component = this;
		return this.state.valores_dinamicos.filter(function (valorDinamico) {
			if (!component.esItemRelevante(valorDinamico)) return false;
			let decision = component.decisionActualDe(valorDinamico);
			return decision === null || decision === Constants.ID_DECISION_CANCELADO;
		});
	}

	renderItem(valorDinamico, index) {
		if (!this.esItemRelevante(valorDinamico)) return null;

		let intl = this.props.intl;
		let borrador = this.state.decisionesBorrador[valorDinamico.id];
		let vigente = valorDinamico.ultima_validacion;
		let vigenteActiva = !!(vigente && vigente.decision !== Constants.ID_DECISION_CANCELADO);
		let decisionActual = this.decisionActualDe(valorDinamico);
		let mostrarBotonesDecision = (decisionActual === null || decisionActual === Constants.ID_DECISION_CANCELADO);

		let seleccionado = this.state.seleccionMultiple.has(valorDinamico.id);

		return (
			<div className={'row align-items-start border-bottom py-2 mx-0' + (seleccionado ? ' bg-primary bg-lighten-5' : '')} key={index}>
				<div className="col-1 pt-1">
					{mostrarBotonesDecision &&
						<input
							type="checkbox"
							checked={seleccionado}
							onChange={() => this.toggleSeleccionMultiple(valorDinamico.id)}
						/>
					}
				</div>
				<div className="col-3 text-truncate" title={valorDinamico.nombre}>
					{valorDinamico.nombre}
				</div>
				<div className="col-3">
					{Constants.INSTANCIAS_DICT[valorDinamico.tipoValor].conAdjunto ?
						<span>
							{valorDinamico.value && typeof (valorDinamico.value) === 'number' &&
								<i onClick={() => this.openImage(valorDinamico.value)} className="cursor-pointer pr-1 fa fa-2x fa-paperclip"></i>
							}
							{valorDinamico.value && typeof (valorDinamico.value) !== 'number' && valorDinamico.value.map((e, i) =>
								<i key={i} onClick={() => this.openImage(e)} className="cursor-pointer pr-1 fa fa-2x fa-paperclip"></i>
							)}
							{!valorDinamico.value &&
								<FormattedMessage id="formularioDetail.information_no_posee_adjunto" defaultMessage="No posee adjunto" />
							}
						</span>
						:
						<span className={
							valorDinamico.estado === Constants.ID_ESTADO_APROBACION_INVALIDO ? 'danger' :
								valorDinamico.estado === Constants.ID_ESTADO_APROBACION_VALIDO ? 'success' : ''
						}>
							{valorDinamico.value}
						</span>
					}
					{valorDinamico.adjuntos && valorDinamico.adjuntos.map((a, i) =>
						<i key={i} onClick={() => this.openImage(a.adjunto_id)} className="cursor-pointer pr-1 fa fa-1_4x fa-paperclip"></i>
					)}
				</div>
				<div className="col-5">
					{borrador &&
						<div className="text-truncate">
							<small className={
								borrador.decision === Constants.ID_DECISION_INVALIDO ? 'danger' :
									borrador.decision === Constants.ID_DECISION_VALIDO ? 'success' : 'warning'
							}>
								<strong><FormattedMessage id="formularios.validacionGranular.pendiente" defaultMessage="Pendiente:" /></strong>
								{' '}
								{borrador.decision === Constants.ID_DECISION_VALIDO &&
									intl.formatMessage({ id: 'formularios.validacionGranular.decision_valido_accion', defaultMessage: 'Validar' }) + this.formatoMotivo(borrador.motivo)
								}
								{borrador.decision === Constants.ID_DECISION_INVALIDO &&
									intl.formatMessage({ id: 'formularios.validacionGranular.decision_invalido_accion', defaultMessage: 'Rechazar' }) + this.formatoMotivo(borrador.motivo)
								}
								{borrador.decision === Constants.ID_DECISION_CANCELADO &&
									intl.formatMessage({ id: 'formularios.validacionGranular.decision_reabrir_accion', defaultMessage: 'Reabrir' })
								}
							</small>
							<button type="button" className="btn btn-sm btn-link p-0 ml-1" onClick={() => this.quitarMarca(valorDinamico.id)}>
								<FormattedMessage id="formularios.validacionGranular.quitar_marca" defaultMessage="Quitar marca" />
							</button>
						</div>
					}
					{!borrador && vigenteActiva &&
						<div className="text-truncate">
							<small className={vigente.decision === Constants.ID_DECISION_INVALIDO ? 'danger' : 'success'}>
								<FormattedMessage
									id="formularios.validacionGranular.estado_decision"
									defaultMessage="{decision}{motivo} - {usuario} el {fecha}"
									values={{
										decision: vigente.decision === Constants.ID_DECISION_VALIDO
											? intl.formatMessage({ id: 'formularios.validacionGranular.decision_valido_label', defaultMessage: 'Validado' })
											: intl.formatMessage({ id: 'formularios.validacionGranular.decision_invalido_label', defaultMessage: 'Rechazado' }),
										motivo: this.formatoMotivo(vigente.motivo),
										usuario: vigente.usuario_validador ? vigente.usuario_validador.nombre : '',
										fecha: Timezone.getDateForClient(vigente.created_at, null, 'DD/MM/YYYY HH:mm'),
									}}
								/>
							</small>
						</div>
					}
					{!borrador && !vigenteActiva &&
						<div className="text-truncate">
							<small className="text-muted">
								<FormattedMessage id="formularios.validacionGranular.sin_decision" defaultMessage="Sin decisión (conforme por defecto)" />
							</small>
						</div>
					}
					<div className="d-inline-flex mt-1">
						{mostrarBotonesDecision &&
							<React.Fragment>
								<button
									className="btn btn-sm btn-icon btn-dt-grid text-success"
									title={intl.formatMessage({ id: 'formularios.validacionGranular.boton_validar', defaultMessage: 'Validar' })}
									onClick={() => this.marcarValido(valorDinamico)}
								>
									<i className="fa fa-check"></i>
								</button>
								<button
									className="btn btn-sm btn-icon btn-dt-grid text-danger"
									title={intl.formatMessage({ id: 'formularios.validacionGranular.boton_rechazar', defaultMessage: 'Rechazar' })}
									onClick={() => this.marcarInvalido(valorDinamico)}
								>
									<i className="fa fa-times"></i>
								</button>
							</React.Fragment>
						}
						{!mostrarBotonesDecision && !borrador &&
							<button
								className="btn btn-sm btn-icon btn-dt-grid text-secondary"
								title={intl.formatMessage({ id: 'formularios.validacionGranular.boton_deshacer', defaultMessage: 'Deshacer / Reabrir' })}
								onClick={() => this.marcarReapertura(valorDinamico)}
							>
								<i className="fa fa-undo"></i>
							</button>
						}
					</div>
				</div>
			</div>
		);
	}

	render() {
		let intl = this.props.intl;
		let cantidadCambiosSinGuardar = Object.keys(this.state.decisionesBorrador).length;
		let cantidadFaltantesPorDecidir = this.itemsPendientesDeDecision().length;

		return (
			<div className="modal fade" tabIndex="-1" id={this.state.modalId} role="dialog" aria-labelledby={this.state.modalId + '_label'}>
				<div className="modal-dialog modal-lg" role="document">
					<div className="modal-content">
						<div className="modal-header bg-fleet">
							<h4 className="modal-title text-white" id={this.state.modalId + '_label'}>
								<i className="ft-info align-middle icon-modal-title"></i>
								<FormattedMessage id="formularios.validacionGranular.titulo_modal" defaultMessage="Validación de checklist" />
							</h4>
						</div>
						<div className="modal-body modal-grey modal-mh" style={{ maxHeight: '65vh', overflowY: 'auto' }}>
							{this.state.loading ?
								<div className="text-center py-4">
									<i className="fa fa-spinner fa-spin fa-2x"></i>
								</div>
								:
								<React.Fragment>
									<div className="row font-weight-bold border-bottom pb-1 mx-0">
										<div className="col-1">
											{this.itemsPendientesDeDecision().length > 0 &&
												<input
													type="checkbox"
													checked={this.itemsPendientesDeDecision().every((vd) => this.state.seleccionMultiple.has(vd.id))}
													onChange={this.toggleSeleccionarTodos}
												/>
											}
										</div>
										<div className="col-3"><FormattedMessage id="formularios.validacionGranular.col_item" defaultMessage="Ítem" /></div>
										<div className="col-3"><FormattedMessage id="formularios.validacionGranular.col_operador" defaultMessage="Registrado por el operador" /></div>
										<div className="col-5"><FormattedMessage id="formularios.validacionGranular.col_supervisor" defaultMessage="Decisión del supervisor" /></div>
									</div>
									{this.state.valores_dinamicos.map((valorDinamico, index) => this.renderItem(valorDinamico, index))}
								</React.Fragment>
							}
						</div>
						<div className="modal-footer">
							<span className="mr-auto text-muted">
								{!this.state.loading && cantidadFaltantesPorDecidir > 0 &&
									<div>
										<FormattedMessage
											id="formularios.validacionGranular.faltan_por_decidir"
											defaultMessage="Faltan {cantidad} ítem(s) por decidir"
											values={{ cantidad: cantidadFaltantesPorDecidir }}
										/>
									</div>
								}
								{cantidadCambiosSinGuardar > 0 &&
									<div>
										<FormattedMessage
											id="formularios.validacionGranular.cantidad_pendientes"
											defaultMessage="{cantidad} ítem(s) con cambios sin guardar"
											values={{ cantidad: cantidadCambiosSinGuardar }}
										/>
									</div>
								}
							</span>
							{this.idsSeleccionadosValidos().length > 0 &&
								<React.Fragment>
									<span className="text-muted mr-2">
										<FormattedMessage
											id="formularios.validacionGranular.cantidad_seleccionados"
											defaultMessage="{cantidad} ítem(s) seleccionados"
											values={{ cantidad: this.idsSeleccionadosValidos().length }}
										/>
									</span>
									<button
										type="button"
										className="btn btn-sm btn-icon btn-dt-grid text-success"
										title={intl.formatMessage({ id: 'formularios.validacionGranular.validar_seleccionados', defaultMessage: 'Validar seleccionados' })}
										onClick={() => this.aplicarDecisionMasiva(Constants.ID_DECISION_VALIDO)}
									>
										<i className="fa fa-check"></i>
									</button>
									<button
										type="button"
										className="btn btn-sm btn-icon btn-dt-grid text-danger mr-2"
										title={intl.formatMessage({ id: 'formularios.validacionGranular.rechazar_seleccionados', defaultMessage: 'Rechazar seleccionados' })}
										onClick={() => this.aplicarDecisionMasiva(Constants.ID_DECISION_INVALIDO)}
									>
										<i className="fa fa-times"></i>
									</button>
								</React.Fragment>
							}
							<button type="button" className="btn btn-secondary" onClick={this.handleCerrar} disabled={this.state.submitting}>
								<FormattedMessage id="formularios.validacionGranular.boton_cerrar" defaultMessage="Cerrar" />
							</button>
							<button
								type="button"
								className="btn btn-primary"
								onClick={this.handleConcluir}
								disabled={this.state.submitting || this.state.loading || cantidadCambiosSinGuardar === 0 || cantidadFaltantesPorDecidir > 0}
							>
								<FormattedMessage id="formularios.validacionGranular.boton_concluir" defaultMessage="Concluir validación" />
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default ValidacionGranularModal;
